// TODO: Move to frontend-common and merge with account version when creator app using preact
import type { ReactElement } from "preact/compat";
import { useState } from "preact/compat";
import type { TargetedSubmitEvent } from "preact";
import { useLocalStorage } from "react-use";
// TODO: Remove react-use - not many usages left

type PasswordProtectedProps = {
	readonly children: ReactElement;
};

const passwordKey = "protectionPassword";
const requiredPassword = "House64Testing";

function PasswordProtected({ children }: PasswordProtectedProps): ReactElement {
	const [savedPassword, setSavedPassword] = useLocalStorage(passwordKey, "");
	const [password, setPassword] = useState("");
	const [hasPasswordError, setHasPasswordError] = useState(false);
	const onSubmit = (e: TargetedSubmitEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (password === requiredPassword) {
			setHasPasswordError(false);
			setSavedPassword(password);
			return;
		}

		setHasPasswordError(true);
	};

	if (savedPassword === requiredPassword) {
		return children;
	}

	return (
		<div style={{ textAlign: "center" }}>
			<h1 style={{ fontSize: 30, fontWeight: "bold" }}>Brick.me staging</h1>
			<p style={{ marginTop: 15, marginBottom: 15 }}>
				Enter password to proceed
			</p>
			<form onSubmit={onSubmit}>
				<div style={{ marginTop: 15, marginBottom: 15 }}>
					<input
						type="password"
						placeholder="Password"
						value={password}
						onChange={(e) =>
							setPassword(e.target ? (e.target as HTMLInputElement).value : "")
						}
					/>
				</div>
				<button
					type="submit"
					style={{
						background: "#bdbdbd",
						border: "1px solid black",
						padding: 5,
					}}
				>
					Submit
				</button>
				{hasPasswordError && (
					<div style={{ color: "red" }}>Incorrect password</div>
				)}
			</form>
			<p style={{ marginTop: 15, marginBottom: 15 }}>
				Looking for the real brick.me site?{" "}
				<a href="https://brick.me" style={{ color: "blue" }}>
					It&apos;s at https://brick.me
				</a>
			</p>
		</div>
	);
}

export default PasswordProtected;
